import { AuthStore, SessionStorageAuthProvider } from "./auth";
import { AppStateStore } from "./app-state";
import { APIResourceAuthProvider, ContainerAuthProvider } from "./auth/provider";
export class RootStore {
    auth;
    app;
    static default() {
        const appStore = new AppStateStore();
        const authStore = new AuthStore(new ContainerAuthProvider(new SessionStorageAuthProvider(), new APIResourceAuthProvider(appStore)));
        const root = new RootStore(appStore, authStore);
        return root;
    }
    constructor(app, auth) {
        this.app = app;
        this.app.setRoot(app);
        this.auth = auth;
        this.auth.setRoot(this);
    }
}
let DEFAULT_STORE;
export function getDefaultStore(createIfUndefined = false) {
    if (DEFAULT_STORE === undefined) {
        if (!createIfUndefined) {
            throw new Error('Default store has not been initialised');
        }
        DEFAULT_STORE = RootStore.default();
    }
    return DEFAULT_STORE;
}
//# sourceMappingURL=root-store.js.map